import {
  Component,
  OnInit,
  Output,
  EventEmitter,
  Input
} from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { take } from 'rxjs/operators';
import { CompanyFilters } from 'src/app/domains/companies/models';

@Component({
  selector: 'gdp-companies-table-filters',
  templateUrl: './companies-table-filters.component.html',
  styleUrls: ['./companies-table-filters.component.scss']
})
export class CompaniesTableFiltersComponent implements OnInit {
  @Input() filters: CompanyFilters;
  @Output() filtersChanged = new EventEmitter<CompanyFilters>()
  form: UntypedFormGroup;
  availableFilters = ['id', 'alphaname', 'email', 'did', 'billingId', 'name'];
  usedFilters = [];
  private integerPattern = /^\d+/;

  constructor(
    private fb: UntypedFormBuilder,
    private route: ActivatedRoute
  ) { }

  ngOnInit() {
    this.form = this.fb.group({});
    this.route.queryParams
      .pipe(take(1))
      .subscribe(params => {
        if (Object.keys(params).length) {
          [...this.availableFilters].forEach((item) => {
            if (params[item]) {
              this.filters[item] = params[item];
              this.addFilter(this.availableFilters.indexOf(item));
            }
          })
        }
        else {
          if (this.filters && Object.keys(this.filters).every(k => { return [null, '', undefined].includes(this.filters[k]); })) {
            this.addFilter(this.availableFilters.indexOf('name'));
          }
          else {
            for (let key in this.filters) {
              if (this.filters[key]) {
                this.addFilter(this.availableFilters.indexOf(key));
              }
            }
          }
        }
        this.emitFilters(null);
      }
      );
  }

  public addFilter(index: number) {
    let filter: string = this.availableFilters[index];
    this.usedFilters.push(this.availableFilters[index]);
    this.availableFilters.splice(index, 1);
    switch (filter) {
      case 'id':
      case 'billingId':
      case 'did':
        this.form.addControl(filter, new UntypedFormControl(this.filters[filter], Validators.pattern(this.integerPattern)));
        break;
      default:
        this.form.addControl(filter, new UntypedFormControl(this.filters[filter]));
        break;
    }
  }

  public removeFilter(index: number) {
    let filter = this.usedFilters[index];
    this.availableFilters.push(this.usedFilters[index]);
    this.usedFilters.splice(index, 1);
    this.availableFilters.sort();
    this.filters[filter] = this.form.get(filter).value;
    this.form.removeControl(filter);
  }

  public emitFilters(event) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    if (this.form.valid) {
      let value = this.form.value;
      this.filtersChanged.emit(value);
    }
  }

  public updateFilters(index: number, oldIndex: number) {
    let toRemove: string = this.usedFilters[oldIndex];
    let toAdd: string = this.availableFilters[index];
    this.usedFilters[oldIndex] = this.availableFilters[index];
    this.availableFilters.splice(index, 1);
    this.availableFilters.push(toRemove);
    this.availableFilters.sort();
    this.filters[toRemove] = this.form.get(toRemove).value;
    switch (toAdd) {
      case 'id':
      case 'billingId':
      case 'did':
        this.form.addControl(toAdd, new UntypedFormControl(this.filters[toAdd], Validators.pattern(this.integerPattern)));
        break;
      default:
        this.form.addControl(toAdd, new UntypedFormControl(this.filters[toAdd]));
        break;
    }
    this.form.removeControl(toRemove);
  }

  public resetFilters() {
    this.form = this.fb.group({
      name: new UntypedFormControl('')
    });
    this.availableFilters = ['id', 'alphaname', 'email', 'did', 'billingId'];
    this.usedFilters = ['name'];
    this.filters = {
      name: null,
      id: null,
      alphaname: null,
      email: null,
      did: null,
      billingId: null
    }
  }
}
